import React from "react";
import { Form, Input, Button, Card, Tag, Typography } from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { defaultSocialLinks } from "./defaults";
import { LucideIconPicker } from "./LucideIconPicker";
import type { SectionMeta } from "./types";

const { Text } = Typography;

export const meta: SectionMeta = {
  key: "social_links",
  label: "Social Media Links",
  icon: <ShareAltOutlined />,
  color: "#06b6d4",
  desc: "Facebook, Instagram, Twitter, etc.",
};

export const defaultData = defaultSocialLinks;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {data.map((item: any, i: number) => (
        <Tag
          key={i}
          color="cyan"
          className="!m-0 !text-xs !leading-5 !font-medium !px-2"
        >
          {item.name}
        </Tag>
      ))}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="social_links">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-3 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "name"]}
                label="Platform"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Facebook" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "href"]}
                label="Profile URL"
                className="!mb-0 col-span-2"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="https://facebook.com/yourpage" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "icon"]}
                label="Icon"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <LucideIconPicker />
              </Form.Item>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add()}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add Social Link
        </Button>
      </>
    )}
  </Form.List>
);
